module.exports = __webpack_public_path__ + "img/holiday_checklist.59e98df8.webp";